var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4029_3786",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 5.91278e-05H19.9999V20H0V5.91278e-05Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4029_3786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7948 16.7949C13.0421 20.5475 6.95782 20.5475 3.20514 16.7949C-0.547546 13.0422 -0.547546 6.95786 3.20514 3.20518C6.95782 -0.54751 13.0421 -0.54751 16.7948 3.20518C20.5475 6.95786 20.5475 13.0422 16.7948 16.7949Z",
    fill: "url(#paint0_linear_4029_3786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3464 5.46288L8.69146 10.1178L6.65377 8.08018L4.44409 10.2899L6.48174 12.3276L8.69146 14.5372L10.9011 12.3276L15.5561 7.6726L13.3464 5.46288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.3464 5.46288L8.69146 10.1178L6.65377 8.08018L4.44409 10.2899L6.48174 12.3276L8.69146 14.5372L10.9011 12.3276L15.5561 7.6726L13.3464 5.46288Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.6006 17.8104C11.8456 20.5098 6.58161 20.1713 3.20514 16.7948C-0.547546 13.0422 -0.547546 6.95789 3.20514 3.2052C6.95782 -0.547482 13.0421 -0.547482 16.7948 3.2052C20.1713 6.58168 20.5098 11.8457 17.8103 15.6006",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4029_3786",
    x1: 9.99998,
    y1: 19.6094,
    x2: 9.99998,
    y2: 0.390663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98EF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17C467"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.ebdcd3eb95f312e0081369542b7d67d0.svg";
export { ForwardRef as ReactComponent };